import axios from '../utils/axios';
import API_ENDPOINTS from '../constants/api-endpoints';
import { useQuery, useMutation, useQueryClient } from 'react-query';

export const useGapReasonPending = (enabled = true) => {
    return useQuery(
        [API_ENDPOINTS.GAP_REASON_PENDING],
        () => axios.get(API_ENDPOINTS.GAP_REASON_PENDING),
        {
            select: (res) => res.data,
            enabled,
            refetchInterval: 2 * 60 * 1000,
            refetchOnWindowFocus: true,
        }
    );
};

export const useAnswerGapReason = () => {
    const queryClient = useQueryClient();
    return useMutation(
        ({ id, reason, relatedLeadNumber }) => axios.post(API_ENDPOINTS.GAP_REASON_ANSWER, { id, reason, relatedLeadNumber }),
        {
            // onSettled (not onSuccess): a flagged/rejected answer comes back as an HTTP error,
            // but the pending gap still needs refetching so the flagged state/message shows up.
            onSettled: () => {
                queryClient.invalidateQueries([API_ENDPOINTS.GAP_REASON_PENDING]);
            }
        }
    );
};

export const useGapReasonList = (userId, options = {}) => {
    return useQuery(
        [API_ENDPOINTS.GAP_REASON_LIST, userId],
        () => axios.get(API_ENDPOINTS.GAP_REASON_LIST, { params: userId ? { userId } : {} }),
        {
            select: (res) => res.data,
            ...options,
        }
    );
};
